<script setup lang="ts">
import { computed } from 'vue';
import { fieldPropDefs, useFieldProps } from './props';
import InputSwitch from 'primevue/inputswitch';
import InputText from 'primevue/inputtext';

const props = defineProps({
    ...fieldPropDefs,
    onMessage: {
        type: String,
        default: 'Ja',
    },
    offMessage: {
        type: String,
        default: 'Nee',
    },
    placeholder: {
        type: String,
        default: '-- Maak een keuze --',
    },
    helpText: {
        type: String,
        default: null,
    },
});
const emit = defineEmits(['update:modelValue']);
const { id, name, fieldProps, modelValue } = useFieldProps(props, emit);

const helpId = computed(() => `${id.value}-help`);

const message = computed(() => {
    if (modelValue.value === null || modelValue.value === undefined)
        return props.placeholder;
    return modelValue.value ? props.onMessage : props.offMessage;
});
</script>

<template>
    <Field v-bind="fieldProps">
        <div class="p-inputtext p-component switch-container">
            <div class="switch-text">
                <span>{{ message }}</span>
                <slot />
            </div>

            <div class="switch-switch">
                <InputSwitch
                    v-bind="$attrs"
                    v-model="modelValue"
                    :input-id="id"
                    :input-class="props.inputClass"
                    :input-style="props.inputStyle as any"
                    :input-props="{ name: name }"
                    class="field-input"
                />
            </div>
        </div>

        <small v-if="props.helpText" :id="helpId">{{ props.helpText }}</small>
        <template #readonly>
            <InputText v-model="message" :disabled="true" :readonly="true" />
        </template>
    </Field>
</template>

<style scoped lang="scss">
.switch-container {
    display: flex;
    flex-direction: row;
    padding: 0;
}
.switch-text {
    flex: 1 1 auto;
    margin: 0.7rem;
}
.switch-switch {
    display: flex;
    align-items: center;
    margin-right: 0.5rem;
}
</style>
